import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import CompaniesService from 'api/services/CompaniesService';
import { RootState } from 'store/store';
import { TCompanyParams, TRole, USER_STATUS } from 'store/types';

export const fetchCompanies = createAsyncThunk('fetchCompanies', async () => {
    const response = await CompaniesService.companies();
    return response.data;
});

export const fetchSingleCompany = createAsyncThunk('fetchSingleCompany', async (params: TCompanyParams) => {
    const response = await CompaniesService.company(params);
    return response.data;
});

export const fetchCompanyUsers = createAsyncThunk<any, void, { state: RootState }>(
    'fetchCompanyUsers',
    async (_, { getState }) => {
        const companyId = getState().userState.me.data.company.id;
        const response = await CompaniesService.users({ companyId });
        return response.data;
    },
);

type TCompaniesState = {
    companies: {
        data: Array<{
            id: string;
            name: string;
            roles: Array<{
                id: string;
                name: string;
                type: string;
            }>;
            teams: Array<{
                id: string;
                title: string;
            }>;
        } | null>;
        isLoading: boolean;
    };
    company: {
        data:
            | {}
            | {
                  id: string;
                  name: string;
                  roles: Array<TRole>;
                  teams: Array<{
                      id: string;
                      title: string;
                  }>;
              };
        isLoading: boolean;
    };
    users: {
        data: Array<{ globalRole: string; id: string; name: string; status: USER_STATUS }>;
        isLoading: boolean;
    };
};

const initialState: TCompaniesState = {
    companies: {
        data: [],
        isLoading: false,
    },
    company: {
        data: {},
        isLoading: false,
    },
    users: {
        data: [],
        isLoading: false,
    },
};

export const companiesSlice = createSlice({
    name: 'companies',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchCompanies.pending, state => {
                state.companies.isLoading = true;
            })
            .addCase(fetchCompanies.fulfilled, (state, action) => {
                state.companies.data = action.payload;
                state.companies.isLoading = false;
            });
        builder
            .addCase(fetchSingleCompany.pending, state => {
                state.company.isLoading = true;
            })
            .addCase(fetchSingleCompany.fulfilled, (state, action) => {
                state.company.data = action.payload;
                state.company.isLoading = false;
            });
        builder
            .addCase(fetchCompanyUsers.pending, state => {
                state.users.isLoading = true;
            })
            .addCase(fetchCompanyUsers.fulfilled, (state, action) => {
                state.users.data = action.payload;
                state.users.isLoading = false;
            });
    },
});

export const selectCompanies = createSelector(
    [(state: RootState) => state.companiesState.companies],
    data => data.data,
);
export const selectCompaniesIsLoading = createSelector(
    [(state: RootState) => state.companiesState.companies],
    data => data.isLoading,
);

export const selectCompanyUsers = createSelector(
    [(state: RootState) => state.companiesState.users],
    data => data.data,
    //.filter(user => user.status === USER_STATUS.active),
);
export const selectCompanyUsersIsLoading = createSelector(
    [(state: RootState) => state.companiesState.users],
    data => data.isLoading,
);

export default companiesSlice.reducer;
